<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Karandak Auditions</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Karandak Auditions</h2>
        </div>
        <p class="card-text">रायसोनी करंडक एकांकिका स्पर्धेच्या प्राथमिक फेरीची नांदी  </p>

        <P>राज्यभरातून ६९ महाविद्यालये झाली सहभागी</P>
        <p>जी. एच. रायसोनी स्पोर्ट्स अँड कल्चरल फाउंडेशनच्या वतीने आयोजित जी.एच. रायसोनी करंडक राज्यस्तरीय आंतरमहाविद्यालयीन एकांकिका स्पर्धेच्या प्राथमिक फेरीची नांदी झाली असून पहिल्या टप्प्याची सुरवात  रत्नागिरी, ( दिनांक २४ ऑक्टोबर )  कोल्हापूर ( २५ आणि २६ ऑक्टोबर ) आणि पुण्यातून २८ आणि २९ आक्टोबर  ला  होत आहे.  या स्पर्धेत राज्यभरातुन एकूण ६९ महाविद्यालये सहभागी झाली असून यात अमरावती, पुणे, कोल्हापूर, नागपूर, औरंगाबाद, धुळे, जळगाव, रत्नागिरी, मुंबई, नाशिक, नांदेड, सिंधुदुर्ग , बारामती  आणि सोलापुरातून महाविद्यालयांनी भरघोस प्रतिसाद दिलेला आहे. प्राथमिक आणि अंतिम अशा दोन फेरीत आयोजित, या स्पर्धेची प्राथमिक फेरी त्या त्या केंद्रावर होऊ घातलेली आहे.</p>
        <p>नुकतीच जी एच रायसोनी करंडक एकांकिका स्पर्धेच्या प्राथमिक फेरीची नांदी झालेली असून   दिनांक  २४ ऑक्टोबर, २०२४ रोजी
            रत्नागिरी  संघाची  प्राथमिक फेरी राधाबाई शेट्ये सभागृह ( २२ नंबर हॉल ) , गोगटे जोगळेकर महाविद्यलाय, रतनागिरीमध्ये पार  पडली आहे , या वेळी परीक्षक म्हणून  रत्नागिरीतील जेस्ट रंगकर्मी माननीय  किशोर साठे,  पुण्यातील  सुप्रसिद्ध  दिगदर्शक माननियय  शेखर  नाईक, आणि नागपूर मधील अभिनेत्री  वैदेही  चवरे यांनी प्राथमिक  फेरीचे परीक्षक म्हणून  काम पहिले, यावेळी    जी एच रायसोनी करंडक तर्फे प्राथमिक फेरी मधील सर्व सहभागी  संघाना प्रशस्तीपत्र प्रदान आले. </p>
        <p>स्पर्धेचा निकाल खालीलप्रमाणे -
            प्रथम  पारितोषिक  - डी. बी. जे. कॉलेज - लेटर बॉक्स १४३</p>
            <p>द्वितीय पारितोषिक - आठल्ये सप्रे पित्रे महाविद्यालय - हिरो नंबर वन </p>
            <p>तृतीय पारितोषिक - सिद्धयोग  लॉ  कॉलेज - समाप्त </p>
        <p>स्पर्धेची अंतिम फेरी १ ते ४ फेब्रुवारी, २०२५ या कालावधीत नागपूर येथे आयोजित करण्यात  आलेली आहे. अंतिम फेरीत सर्वोत्कृष्ठ निर्मितीसाठी प्रथम १ लाख ११ हजार, द्वितीय ७१,००० तर तृतीय ५१,००० तसेच २१ हजारांचे दोन उत्तेजनार्थ रुपये रोख पुरस्कार दिले जाणार आहेत. याशिवाय सर्वोत्कृष्ठ निर्मितीसाठी दोन उत्तेजनार्थ पारितोषिके असे देण्यात येणार आहेत .</p>
            <div class="row row-cols-1 row-cols-lg-3 mt-5">
                <div class="col">
                    <div class="hom-trend text-center">
                        <div class="hom-trend-img pgm-div">
                            <a routerLink="/karandak-auditions-kolhapur" class="shadow-inset img-cla">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/karandak.avif"
                                    alt="Karandak Auditions" title="Karandak Auditions"></a>

                            <h4>Karandak Auditions- kolhapur</h4>
                            <h5> 29<sup>th</sup> Oct 2023 </h5>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="hom-trend text-center">
                        <div class="hom-trend-img pgm-div">
                            <a routerLink="/karandak-auditions-ratnagiri" class="shadow-inset img-cla">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/karandak.avif"
                                    alt="Karandak Auditions" title="Karandak Auditions"></a>

                            <h4>Karandak Auditions- Ratnagiri</h4>
                            <h5> 29<sup>th</sup> Oct 2023 </h5>
                        </div>
                    </div>
                </div>


                <div class="col">
                    <div class="hom-trend text-center">
                        <div class="hom-trend-img pgm-div">
                            <a routerLink="/karandak-auditions-pune" class="shadow-inset img-cla">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/karandak.avif"
                                    alt="Karandak Auditions" title="Karandak Auditions"></a>

                            <h4>Karandak Auditions- Pune</h4>
                            <h5> 29<sup>th</sup> Oct 2023 </h5>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</section>
